import { render, staticRenderFns } from "./pl3.vue?vue&type=template&id=05cbabed"
import script from "./pl3.vue?vue&type=script&lang=js"
export * from "./pl3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports